module.exports = __webpack_public_path__ + "static/media/confirm.632d97e8.svg";